<dw-ui-dialog-box
  [title]="'Doc::CustomerInvoice:Cancellation' | abpLocalization"
  [saveLabel]="'Doc::Generate' | abpLocalization"
  (saveFn)="cancelInvoice()"
>
  @if (form) {
    <form [formGroup]="form">
      <div class="row my-2">
        <div>
          <label for="cancellationDocRole" class="form-label text-primary" dwInputRequired>
            {{ 'GoliathCore::DocRole' | abpLocalization }}
          </label>
          <ng-select
            class="form-control"
            id="cancellationDocRole"
            formControlName="cancellationDocRole"
            bindLabel="name.current"
            bindValue="id"
            [loading]="coreEnumationTypeStore.loading()"
            [items]="customerInvoiceCancellationDocRoles"
          >
          </ng-select>
        </div>
      </div>

      <div class="row my-2">
        <div>
          <label for="daybookId" class="form-label text-primary" dwInputRequired>
            {{ 'Doc::DayBook:Selection' | abpLocalization }}
          </label>
          <ng-select
            class="form-control"
            id="daybookId"
            formControlName="daybookId"
            bindLabel="name.current"
            bindValue="id"
            [items]="daybooks$ | async"
          >
          </ng-select>
        </div>
      </div>

      @if (cancellationDocRoleControl.value == DocRole.CustomerReturnNote) {
        <div class="row my-2">
          <div>
            <label
              for="storageLocationId"
              class="form-label text-primary"
              [dwInputRequired]="stockFeature.isEnabled"
            >
              {{ 'GoliathCore::Company:StorageLocation' | abpLocalization }}
            </label>
            <ng-select
              class="form-control"
              id="storageLocationId"
              formControlName="storageLocationId"
              bindLabel="name"
              bindValue="id"
              [dwApiSelect]="storageLocationSelect"
              #locationApiSelect="dwApiSelect"
            >
              <ng-template ng-label-tmp let-item="item">
                <span [title]="item.name">{{ item.name }} [{{ item.code }}]</span>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <span [title]="item.name">{{ item.name }} [{{ item.code }}]</span>
              </ng-template>
            </ng-select>
          </div>
        </div>
      }

      <div class="row my-2">
        <div>
          <label for="description" class="form-label text-primary" dwInputRequired>
            {{ '::Description' | abpLocalization }}
          </label>
          <input id="description" type="text" class="form-control" formControlName="description" />
        </div>
      </div>

      <div class="row my-2">
        <div>
          <label for="paymentTermId" class="form-label text-primary" dwInputRequired>
            {{ 'GoliathCore::PaymentTerm' | abpLocalization }}
          </label>
          <ng-select
            class="form-control"
            id="paymentTermId"
            formControlName="paymentTermId"
            bindLabel="code"
            bindValue="id"
            [items]="paymentTerms"
          >
            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
              <span [title]="item?.name?.current">
                {{ item?.name?.current }} - {{ item.code }}
              </span>
            </ng-template>
          </ng-select>
        </div>
      </div>
    </form>
  }
</dw-ui-dialog-box>
